// src/pages/DashboardGerente.jsx
import React, { useEffect, useState } from "react";
import { Box, Toolbar, Paper, Typography, Grid, TextField, Button, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import { empleados, percepciones, deducciones } from "../services/api";

export default function DashboardGerente() {
  const [emps, setEmps] = useState([]);
  const [per, setPer] = useState([]);
  const [ded, setDed] = useState([]);
  const [loading, setLoading] = useState(false);

  const [formPer, setFormPer] = useState({ empleado_id: "", tipo: "", monto: "", descripcion: "" });
  const [formDed, setFormDed] = useState({ empleado_id: "", tipo: "", monto: "", descripcion: "" });

  const load = async () => {
    setLoading(true);
    try {
      const [e, p, d] = await Promise.all([empleados.list(), percepciones.list(), deducciones.list()]);
      setEmps(e.data || []);
      setPer(p.data || []);
      setDed(d.data || []);
    } catch {
      alert("Error cargando datos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const submitPer = async (e) => {
    e.preventDefault();
    await percepciones.create({ ...formPer, monto: Number(formPer.monto || 0) });
    setFormPer({ empleado_id: "", tipo: "", monto: "", descripcion: "" });
    load();
    alert("Percepción registrada");
  };

  const submitDed = async (e) => {
    e.preventDefault();
    await deducciones.create({ ...formDed, monto: Number(formDed.monto || 0) });
    setFormDed({ empleado_id: "", tipo: "", monto: "", descripcion: "" });
    load();
    alert("Deducción registrada");
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Navbar />
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Typography variant="h5" mb={2}>Dashboard Gerencial</Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="subtitle1" mb={1}>Registrar percepción</Typography>
              <form onSubmit={submitPer}>
                <TextField select SelectProps={{ native: true }} name="empleado_id" label="Empleado" fullWidth margin="dense" value={formPer.empleado_id} onChange={(e)=>setFormPer({...formPer,[e.target.name]:e.target.value})}>
                  <option value="">Selecciona...</option>
                  {emps.map((e)=> <option key={e.id} value={e.id}>{e.nombre}</option>)}
                </TextField>
                <TextField select SelectProps={{ native: true }} name="tipo" label="Tipo" fullWidth margin="dense" value={formPer.tipo} onChange={(e)=>setFormPer({...formPer,[e.target.name]:e.target.value})}>
                  {["","Aguinaldo","Vacaciones","Prima vacacional","Tiempo extra","Sueldo","Incapacidad"].map(t=> <option key={t} value={t}>{t||"Selecciona..."}</option>)}
                </TextField>
                <TextField name="monto" label="Monto" type="number" fullWidth margin="dense" value={formPer.monto} onChange={(e)=>setFormPer({...formPer,monto:e.target.value})}/>
                <TextField name="descripcion" label="Descripción" fullWidth margin="dense" value={formPer.descripcion} onChange={(e)=>setFormPer({...formPer,descripcion:e.target.value})}/>
                <Button type="submit" variant="contained" disabled={loading} sx={{ mt:1 }}>Guardar</Button>
              </form>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="subtitle1" mb={1}>Registrar deducción</Typography>
              <form onSubmit={submitDed}>
                <TextField select SelectProps={{ native: true }} name="empleado_id" label="Empleado" fullWidth margin="dense" value={formDed.empleado_id} onChange={(e)=>setFormDed({...formDed,[e.target.name]:e.target.value})}>
                  <option value="">Selecciona...</option>
                  {emps.map((e)=> <option key={e.id} value={e.id}>{e.nombre}</option>)}
                </TextField>
                <TextField select SelectProps={{ native: true }} name="tipo" label="Tipo" fullWidth margin="dense" value={formDed.tipo} onChange={(e)=>setFormDed({...formDed,[e.target.name]:e.target.value})}>
                  {["","Consumo","Uniforme","Anticipo","Otro"].map(t=> <option key={t} value={t}>{t||"Selecciona..."}</option>)}
                </TextField>
                <TextField name="monto" label="Monto" type="number" fullWidth margin="dense" value={formDed.monto} onChange={(e)=>setFormDed({...formDed,monto:e.target.value})}/>
                <TextField name="descripcion" label="Descripción" fullWidth margin="dense" value={formDed.descripcion} onChange={(e)=>setFormDed({...formDed,descripcion:e.target.value})}/>
                <Button type="submit" variant="contained" disabled={loading} sx={{ mt:1 }}>Guardar</Button>
              </form>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="subtitle1" mb={1}>Percepciones</Typography>
              <Table size="small">
                <TableHead><TableRow><TableCell>Empleado</TableCell><TableCell>Tipo</TableCell><TableCell>Monto</TableCell><TableCell>Fecha</TableCell></TableRow></TableHead>
                <TableBody>
                  {per.map((r)=> (
                    <TableRow key={r.id}>
                      <TableCell>{r.empleado_id}</TableCell>
                      <TableCell>{r.tipo}</TableCell>
                      <TableCell>${Number(r.monto||0).toFixed(2)}</TableCell>
                      <TableCell>{r.fecha}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="subtitle1" mb={1}>Deducciones</Typography>
              <Table size="small">
                <TableHead><TableRow><TableCell>Empleado</TableCell><TableCell>Tipo</TableCell><TableCell>Monto</TableCell><TableCell>Fecha</TableCell></TableRow></TableHead>
                <TableBody>
                  {ded.map((r)=> (
                    <TableRow key={r.id}>
                      <TableCell>{r.empleado_id}</TableCell>
                      <TableCell>{r.tipo}</TableCell>
                      <TableCell>${Number(r.monto||0).toFixed(2)}</TableCell>
                      <TableCell>{r.fecha}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
